var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.00195312 11.0003C0.00195312 10.6026 0.159959 10.2211 0.441211 9.93984C0.722464 9.65859 1.10392 9.50058 1.50167 9.50058H18.8774L12.4376 3.06378C12.156 2.78218 11.9978 2.40023 11.9978 2.00198C11.9978 1.60373 12.156 1.22179 12.4376 0.940179C12.7192 0.658572 13.1012 0.500366 13.4994 0.500366C13.8977 0.500366 14.2796 0.658572 14.5612 0.940179L23.5596 9.9385C23.6992 10.0778 23.81 10.2433 23.8856 10.4255C23.9612 10.6077 24.0002 10.803 24.0002 11.0003C24.0002 11.1976 23.9612 11.3929 23.8856 11.5751C23.81 11.7573 23.6992 11.9228 23.5596 12.0621L14.5612 21.0604C14.2796 21.342 13.8977 21.5002 13.4994 21.5002C13.1012 21.5002 12.7192 21.342 12.4376 21.0604C12.156 20.7788 11.9978 20.3969 11.9978 19.9986C11.9978 19.6004 12.156 19.2184 12.4376 18.9368L18.8774 12.5H1.50167C1.10392 12.5 0.722464 12.342 0.441211 12.0608C0.159959 11.7795 0.00195312 11.3981 0.00195312 11.0003Z",
    fill: "#D9D9D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoRight);
export default __webpack_public_path__ + "static/media/goRight.d0405b98c8e70524db6f67c929acf4f7.svg";
export { ForwardRef as ReactComponent };